var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 38.814,
    viewBox: "0 0 30 38.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svg",
    transform: "translate(-614.698 329.733)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M418.623,1253.267l9.2,9.068h-9.2Z",
    transform: "translate(216.875 -1583)",
    fill: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_3",
    "data-name": "XMLID 86 3",
    transform: "translate(216.875 -1583)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M418.623,1253.267H399.772v38.814h28.051v-29.757Z",
    fill: "#5d5d5d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    transform: "translate(216.875 -1583)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_83_3",
    "data-name": "XMLID 83 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M397.823,1284.745l1.941,1.647v-1.647Z",
    fill: "#fe9700"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_84_3",
    "data-name": "XMLID 84 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1464",
    "data-name": "Rectangle 1464",
    width: 28,
    height: 13.286,
    transform: "translate(397.823 1271.46)",
    fill: "#fe9700"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_.svg",
    "data-name": " .svg",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M402.126,1281.869a.66.66,0,0,1,.468-1.128.607.607,0,0,1,.452.192.682.682,0,0,1,0,.936.61.61,0,0,1-.452.192A.638.638,0,0,1,402.126,1281.869Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M405.423,1281.864a2.044,2.044,0,0,1-.84-.638,1.7,1.7,0,0,1-.34-.942h1a.976.976,0,0,0,.409.712,1.554,1.554,0,0,0,.963.278,1.4,1.4,0,0,0,.872-.245.749.749,0,0,0,.319-.618.609.609,0,0,0-.34-.568,4.749,4.749,0,0,0-1.053-.367,7.663,7.663,0,0,1-1.059-.346,1.883,1.883,0,0,1-.7-.521,1.474,1.474,0,0,1-.026-1.729,1.8,1.8,0,0,1,.755-.59,2.721,2.721,0,0,1,1.117-.218,2.384,2.384,0,0,1,1.563.489,1.763,1.763,0,0,1,.639,1.341h-.969a1,1,0,0,0-.366-.735,1.624,1.624,0,0,0-1.729-.052.686.686,0,0,0-.308.584.638.638,0,0,0,.186.473,1.338,1.338,0,0,0,.468.3,7.692,7.692,0,0,0,.782.25,8.484,8.484,0,0,1,1.021.336,1.774,1.774,0,0,1,.675.494,1.316,1.316,0,0,1,.292.861,1.481,1.481,0,0,1-.265.863,1.767,1.767,0,0,1-.75.6,2.67,2.67,0,0,1-1.111.218A3.029,3.029,0,0,1,405.423,1281.864Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M412.326,1281.1l1.809-4.936h1.032L412.879,1282h-1.127l-2.287-5.829h1.042Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M419.895,1276.4a2.176,2.176,0,0,1,.845.83v-1.065h.979v5.957a2.906,2.906,0,0,1-.341,1.42,2.432,2.432,0,0,1-.973.974,3,3,0,0,1-1.473.35,3.23,3.23,0,0,1-1.915-.542,2.121,2.121,0,0,1-.9-1.478h.957a1.523,1.523,0,0,0,.66.855,2.154,2.154,0,0,0,1.2.326,1.775,1.775,0,0,0,1.3-.5,1.889,1.889,0,0,0,.505-1.405V1280.9a2.328,2.328,0,0,1-.851.851,2.5,2.5,0,0,1-1.319.34,2.654,2.654,0,0,1-2.4-1.457,3.345,3.345,0,0,1-.361-1.574,3.283,3.283,0,0,1,.361-1.57,2.621,2.621,0,0,1,1-1.046,2.719,2.719,0,0,1,1.409-.373A2.6,2.6,0,0,1,419.895,1276.4Zm.579,1.521a1.876,1.876,0,0,0-.718-.75,2.034,2.034,0,0,0-1.983-.006,1.852,1.852,0,0,0-.713.745,2.364,2.364,0,0,0-.266,1.149,2.42,2.42,0,0,0,.266,1.165,1.884,1.884,0,0,0,.713.755,1.92,1.92,0,0,0,.989.26,1.951,1.951,0,0,0,.994-.26,1.869,1.869,0,0,0,.718-.755,2.406,2.406,0,0,0,.266-1.154A2.373,2.373,0,0,0,420.474,1277.923Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.12e79a42bce610d8d053273eeb8c1da4.svg";
export { ForwardRef as ReactComponent };